import { Popover as AntPopover, PopoverProps } from "antd";

const Popover = ({ ...props }: PopoverProps) => {
  return <AntPopover arrow={false} placement="bottomRight" {...props} />;
};

export default Popover;
